import { BUILDER_KEY } from '@/context/projectContext'

type ProjectLike = {
  id: string
}

/**
 * Checks whether a genuine project is selected. Guards against
 * selecting the "Builder" / "All" from the project selector.
 */
export const isProjectSelected = (project: ProjectLike) => {
  if (!project) return false
  if (!project.id) return false
  if (project.id === BUILDER_KEY) return false

  return true
}
